import { PropsCell } from '../../common/Table/TableHeader';

export const headCells: PropsCell[] = [
  { id: 'id', numeric: false, disablePadding: false, label: 'ID' },
  { id: 'from', numeric: false, disablePadding: false, label: 'Origen' },
  { id: 'to', numeric: false, disablePadding: false, label: 'Destino' },
  { id: 'status', numeric: false, disablePadding: false, label: 'Status' },
  { id: 'created', numeric: false, disablePadding: false, label: 'Creado' },
  {
    id: 'finished',
    numeric: false,
    disablePadding: false,
    label: 'Finalizado',
  },
  { id: 'actions', numeric: true, disablePadding: false, label: 'Acciones' },
];

export const fieldsFilter = [
  { key: 'ppt.id', name: 'Id de prestamo' },
  { key: 'origin_user_id', name: 'Id origen' },
  { key: 'target_user_id', name: 'Id destino' },
  { key: 'p2p_transfer_status_id', name: 'Estatus' },
];

export const valuesEstatus = [
  { key: '1', name: 'Pendiente' },
  { key: '2', name: 'Aceptado' },
  { key: '3', name: 'Rechazado' },
  { key: '4', name: 'Aceptada Parcialmente' },
];
